import WORK_KIND from './work-kind'
import STATION from './station'
import PROCEDURE from './procedure'
import PROCESS_ROUTE from './process-route'
import DOSING_DEFAULT_HOUSE from './dosing-default-house'
export default {
	'production-processing': {
		id: 'production-processing',
		label: '生产设置',
		code: '0010_0004',
		child: {
			...WORK_KIND,
			...STATION,
			...PROCEDURE,
			...PROCESS_ROUTE,
			...DOSING_DEFAULT_HOUSE
		}
	}
}
